module.exports = __webpack_public_path__ + "static/media/Support.0064bc48.png";